// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import React from 'react'

import {
  daycareAssistanceLevels,
  preschoolAssistanceLevels
} from 'lib-common/generated/api-types/assistance'
import type { EmployeeCustomizations } from 'lib-customizations/types'

import { employeeConfig } from './appConfigs'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import featureFlags from './featureFlags'

const customizations: EmployeeCustomizations = {
  appConfig: employeeConfig,
  translations: {
    fi: {
      footer: {
        cityLabel: 'Kauniaisten kaupunki',
        linkLabel: 'Kauniaisten varhaiskasvatus',
        linkHref: 'https://www.kauniainen.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatusyksikot/'
      },
      unitEditor: {
        placeholder: {
          email: 'etunimi.sukunimi@kauniainen.fi',
          url: 'esim. https://www.kauniainen.fi/fi/toimipisteet/15585',
        }
      },
      welcomePage: {
        text: 'Olet kirjautunut sisään Kauniaisten kaupungin eVaka-palveluun. Käyttäjätunnuksellesi ei ole vielä annettu oikeuksia, jotka mahdollistavat palvelun käytön. Tarvittavat käyttöoikeudet saat omalta esimieheltäsi.'
      },
      preferredFirstName: {
        description:
          'Voit määritellä eVakassa käytössä olevan kutsumanimesi. Kutsumanimen tulee olla jokin etunimistäsi. Jos nimesi on vaihtunut ja sinulla on tarve päivittää eVakaan uusi nimesi, ole yhteydessä Kauniaisten tukeen.',
      },
      login: {
        loginAD: 'Kauniaisten AD',
      },
    },
    sv: {
      footer: {
        cityLabel: 'Grankulla stad',
        linkLabel: 'Grankulla småbarnspedagogik',
        linkHref: 'https://www.kauniainen.fi/sv/smabarnspedagogik-och-utbildning/enheter-for-smabarnspedagogik/'
      },
      unitEditor: {
        placeholder: {
          email: 'förnamn.efternamn@grankulla.sv',
          url: 'till exempel. https://www.grankulla.sv/sv/kontor/15585',
        }
      },
      welcomePage: {
        text: 'Du är inloggad på Grankulla stads eVaka-tjänst. Ditt användar-ID har ännu inte beviljats ​​rättigheter som möjliggör användningen av tjänsten. Du kan få nödvändiga åtkomsträttigheter från din handledare.',
      },
      preferredFirstName: {
        description:
          'Du kan definiera ditt smeknamn som används i eVaka. Smeknamnet måste vara ett av dina förnamn. Om ditt namn har ändrats och du behöver uppdatera ditt nya namn i eVaka, kontakta Grankulla support.',
      },
      login: {
        loginAD: 'Grankulla AD',
      },
    },
  },
  cityLogo: <img src={MunicipalityLogo} alt="Kauniainen logo" data-qa="footer-city-logo" />,
  featureFlags,
  placementTypes: [
    'PRESCHOOL',
    'PRESCHOOL_DAYCARE',
    'DAYCARE',
    'DAYCARE_PART_TIME',
    'PREPARATORY',
    'PREPARATORY_DAYCARE',
    'CLUB',
    'TEMPORARY_DAYCARE',
    'TEMPORARY_DAYCARE_PART_DAY',
  ],
  absenceTypes: [
    'OTHER_ABSENCE',
    'SICKLEAVE',
    'UNKNOWN_ABSENCE',
    'PLANNED_ABSENCE',
    'PARENTLEAVE',
    'FORCE_MAJEURE',
  ],
  daycareAssistanceLevels: [...daycareAssistanceLevels],
  otherAssistanceMeasureTypes: [
    'TRANSPORT_BENEFIT',
    'ACCULTURATION_SUPPORT',
    'ANOMALOUS_EDUCATION_START',
  ],
  placementPlanRejectReasons: ['REASON_1', 'REASON_2', 'OTHER'],
  preschoolAssistanceLevels: [...preschoolAssistanceLevels],
  unitProviderTypes: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'MUNICIPAL_SCHOOL',
    'PRIVATE_SERVICE_VOUCHER',
    'EXTERNAL_PURCHASED',
  ],
  voucherValueDecisionTypes: [
    'NORMAL',
    'RELIEF_ACCEPTED',
    'RELIEF_PARTLY_ACCEPTED',
    'RELIEF_REJECTED',
  ],
  additionalStaffAttendanceTypes: [
    'OTHER_WORK',
    'TRAINING',
    'JUSTIFIED_CHANGE',
    'SICKNESS',
    'CHILD_SICKNESS',
  ],

}

export default customizations
